import { Button } from '@library/components/buttons';
import { classNames } from '@library/utils';

// depredecated
// use Tabs.tsx
export interface TabProps {
  active: boolean;
  className?: string;
  disabled?: boolean;
  handleClick: (id: string) => void;
  id: string;
  size: 'small' | 'medium';
  tabName: string;
}

export const Tab = ({
  active,
  className = '',
  disabled = false,
  handleClick,
  id,
  size,
  tabName
}: TabProps) => {
  const smallSize = size === 'small';

  const defaultClassname = classNames(
    active
      ? 'border-accent bg-stankonia-100 text-soClean-100 mr-[1px]'
      : '-ml-px hover:bg-soFresh-120 disabled:bg-soFresh-150 disabled:cursor-not-allowed text-soClean-140 bg-soFresh-110 first-of-type:border-l-1',
    smallSize ? 'h-10' : 'h-11',
    'border border-soFresh-140 px-3 py-2 text-xs font-medium first-of-type:rounded-l last-of-type:rounded-r shrink-0'
  );

  return (
    <Button
      aria-pressed={active}
      className={className || defaultClassname}
      disabled={disabled}
      title="TabButton"
      onClick={() => handleClick(id)}
      type="button"
    >
      {tabName}
    </Button>
  );
};
